import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let PageNoData = class PageNoData extends Vue {
};
tslib_1.__decorate([
    Prop({ default: false })
], PageNoData.prototype, "isShowNoData", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], PageNoData.prototype, "isShowSearchNoData", void 0);
tslib_1.__decorate([
    Prop()
], PageNoData.prototype, "tipText", void 0);
PageNoData = tslib_1.__decorate([
    Component({
        name: 'page-no-data'
    })
], PageNoData);
export default PageNoData;
